import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";

import { useLangContext } from "../../context/languageContext";
import { getPageContent, checkVerified } from "../../api/apiRequest";
import { Button, Col, Row } from "react-bootstrap";

const Verify = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [verified,setVerified] = useState(null);
    const [contentDetails,setContentDetails] = useState();
    const {hostLanguage,languageJson} = useLangContext ();
    const getAllPageContent = async() => {
        try
        {
            let apiRes = await  getPageContent(hostLanguage, "verify_email");
            let responseData = await apiRes.json();
            if(responseData.res)
            {
                setContentDetails(responseData.data);
            }
            else
            {
                console.error(responseData.msg,'',2000);
            }
        }
        catch(error)
        {
            console.error(error);
        }
    }

    const completeVerifyMail = async() => {
        try {
            let apiRes = await checkVerified({email_token: searchParams.get("token")});
            let responseData = await apiRes.json();
            if(responseData.res)
            {
                setVerified(true);
            }
            else
            {
                setVerified(false);
            }
        }catch(error) {

        }
    }

    useEffect(()=>{
        getAllPageContent();
        completeVerifyMail();
    },[hostLanguage])

    return (
        <div>
            <div className="MainBody">
                <Link to='/'>
                    <img src="/images/cleverdomizil-logo.webp" className="MainLogo" alt={"Logo"}/>
                </Link>
                <h1>{contentDetails?.verify_email?.title}</h1>
                {verified == null ? (
                    <p>{contentDetails?.verify_email?.desc}</p>
                ) : 
                    verified ? (
                        <>{contentDetails?.verify_email?.success}</>
                    ): (
                        <>{contentDetails?.verify_email?.failed}</>
                    )
                }
                <Row>
                    <Col sm={12}>
                        <Button
                            variant="primary"
                            type="submit"
                            className="BtnSubmit w-auto mt-4"
                            onClick={(e) => navigate("/")}
                        >{contentDetails?.verify_email?.back}</Button>
                    </Col>
                </Row>
            </div>
        </div>
    );
};
export default Verify;